module.exports = __webpack_public_path__ + "static/media/cloudsMain.dd445777.png";